/**
 * Docket entry Print
 */
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PrintState = {
  totalDocketEntryIds: [],
}

export const PrintActions = {
  getDocketEntriesForPrint: async (_, requestData) => {
    return axiosRequest.
      post('/print_docket_entries', requestData).
      then(({ data }) => data || {}).
      catch(handleError)
  },

  totalDocketEntryIds ({ commit }, data) {
    commit('setTotalDocketEntryIds', data)
  },
}

export const PrintMutations = {
  setTotalDocketEntryIds: (state, value) => {
    state.totalDocketEntryIds = value
  },
}

export const PrintGetters = {
  filteredDocketEntriesIds: state => {
    return state.totalDocketEntryIds
  },
}
